"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectDateHeadersOption_1 = require("../actions/selectDateHeadersOption");
var store_1 = require("../store/store");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var isDateHeaderEnabled_1 = require("../utils/isDateHeaderEnabled");
var owa_options_core_1 = require("owa-options-core");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var DateHeadersFull = /** @class */ (function (_super) {
    tslib_1.__extends(DateHeadersFull, _super);
    function DateHeadersFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectDateHeadersOption_1.default(option.key === 'true');
        };
        return _this;
    }
    DateHeadersFull.prototype.render = function () {
        var optionStore = this.props.optionStore;
        var isDateHeadersEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.isEnabled, isDateHeaderEnabled_1.default());
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + isDateHeadersEnabled, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_dateHeaders_enabled,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_dateHeaders_disabled,
                },
            ], onChange: this.onChange }));
    };
    DateHeadersFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
        })
    ], DateHeadersFull);
    return DateHeadersFull;
}(React.Component));
exports.default = DateHeadersFull;
//# sourceMappingURL=DateHeadersFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-date-headers-option/lib/components/DateHeadersFull.js
// module id = 5081
// module chunks = 2